(function ($) {
    var filterExperienceList, setupFilters;

    filterExperienceList = function (filterFn) {

        $('.guide-map__places__place').each(function() {
            var id, category, childFriendly, displayExperience;

            id = $(this).attr('data-id');
            category = $(this).attr('data-category');
            childFriendly = $(this).attr('data-child-friendly') == 'Y';

            displayExperience = filterFn(id, category, childFriendly);
            $(this).toggle(displayExperience);
        });
    };

    setupFilters = function (guideMap) {
        var onClickApplyFilters;

        onClickApplyFilters = function (e) {
            e.preventDefault();
            var thisCheckbox;

            thisCheckbox = $(this).siblings('input[type="checkbox"]');
            thisCheckbox.prop('checked', !thisCheckbox.prop('checked'));
            thisCheckbox.siblings('.guide-map__filter--label').toggleClass('guide-map__filter--label_active');

            var filter, filterFn, numVisible;

            filter = {
                categories: [],
                onlyChildFriendly: false
            };

            // get selected categories
            $('.js-category-filters input[type="checkbox"]:checked').each(function() {
                filter.categories.push($(this).attr('value'));
            });

            // get child friendly filter value
            $('.js-other-filters input[type="checkbox"]:checked').each(function () {
                if ($(this).attr('value') == 'child_friendly') {
                    filter.onlyChildFriendly = true;
                }
            });

            filterFn = function (id, category, isChildFriendly) {
                var matched =
                    (filter.onlyChildFriendly == false || isChildFriendly == true) &&
                    (filter.categories.length == 0 || $.inArray(category, filter.categories) >= 0);
                return matched;
            };

            guideMap.filterExperiences(filterFn);
            numVisible = filterExperienceList(filterFn);
        };

        // apply category filter
        $('.js-category-filters input[type=\"checkbox\"]').change(onClickApplyFilters);
        // enable checkboxes
        $('.js-other-filters input[type=\"checkbox\"]').change(onClickApplyFilters);
    };

    // exports
    window.setupGuideMapFilters = setupFilters;
})($);

$(function () {
    var filtersCollapsablePanel;

    new CollapsablePanel({
        container: '.guide-map__filters'
    });
});

$(function () {
    var options = $('.js-filter__option');

    options.click(function() {
        var value = $(this).attr('data-filter');
        $('.js-filter').attr('data-filter', value);
        location.hash = value;
    });

    if (location.hash.length > 0) {
        var option = $('.js-filter__option[data-filter="'+(location.hash.replace(/#/,''))+'"]');
        if (option.length > 0) {
            option.trigger('click');
        }
    } else {
        options.eq(0).trigger('click');
    }
});
